import config from '../../../../config/config';
import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';
import * as snackbarActions from "../../../sc-utilities/snackbar/store/snackbarActions";
import snackbarStore from "../../../../snackbarStore";
import { socket } from '../../../..';
import { download } from '../../../sc-utilities/download.utils';
import { CUSTOM } from "../../../sc-utilities/snackbar/store/actionTypes";

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'report-finder',
    pluginName: 'ADMIN',
    entityName: 'REPORT_FINDER',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

// Fetch ReportFinder action creators
export const fetchReportFinderInit = () => {
    return crudActions.fetchInit();
};
export const fetchReportFinderStart = () => {
    return crudActions.fetchStart();
};
export const fetchReportFinderSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchReportFinderFail = () => {
    return crudActions.fetchFail();
};
export const fetchReportFinderCounter = (filter, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchReportFinderStart());
        try {
            let countRes = await rest.post("report-finder/count", filter, { cancelToken: options.countSource.token });
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchReportFinderSuccess(0, []));
                }

                return { data: countRes.data.result.data };
            }
            dispatch(fetchReportFinderFail());
            // snackActions.snackBar({
            //     message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch report finder."}`,
            //     options: {
            //         variant: 'warning'
            //     }
            // });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchReportFinderFail());
            // snackActions.snackBar({
            //     message: `${error.message || "Cannot fetch report finder."}`,
            //     options: {
            //         variant: 'error'
            //     }
            // });
            return { data: [], count: 0 };
        }
    }
};
export const fetchReportFinder = (filter, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchReportFinderStart());
        try {
            let listRes = await rest.post("report-finder/list", filter, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchReportFinderSuccess(filter.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchReportFinderFail());
            return { data: [] };
        } catch (error) {
            dispatch(fetchReportFinderFail());

            return { data: [] };
        }
    }
};


// Create ReportFinder  action creators
export const createReportFinderInit = () => {
    return crudActions.createInit();
};
export const createReportFinderStart = () => {
    return crudActions.createStart();
};
export const createReportFinderSuccess = createdReportFinder => {
    return crudActions.createSuccess(createdReportFinder);
};
export const createReportFinderFail = error => {
    return crudActions.createFail(error);
};

export const createXlsCollection = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            params.append('SocketID', socket.id.split('#')[1]);
            let res = await rest.post('/report/create-collection', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Create collection started.`,
                    options: {
                        variant: 'success'
                    }
                });
                const responseParams = res.data.result.data;
                const redisTopic = responseParams.RedisTopic;
                if (responseParams.AutoDownloadEnabled) {
                    socket.on(redisTopic, async msg => {
                        const { Status, ErasureReportID, RedisTopic } = msg;
                        const { Generated, ToGenerate, Message } = msg;
                        snackbarStore.dispatch(snackbarActions.showCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                        if (Status === 'error') {
                            socket.off(RedisTopic);
                            snackbarStore.dispatch(snackbarActions.hideCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                            snackActions.snackBar({
                                message: Message || `Error: Create collection failed. Please contact administrator.`,
                                options: {
                                    variant: 'error'
                                }
                            });
                            return false;
                        }

                        if (Status === 'generated') {
                            const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ActiveCustomerID=${params.get('ActiveCustomerID')}`;
                            socket.off(RedisTopic);
                            snackbarStore.dispatch(snackbarActions.hideCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                            await download(objUrl);
                            snackActions.snackBar({
                                message: `Create collection finished.`,
                                options: {
                                    variant: 'success'
                                }
                            });
                        }

                    });
                }
                return true;
            } else {
                snackActions.snackBar({
                    message: `Error: Create collection failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `Error: Create collection failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

export const createReportFinder = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(uploadProgress({ progress: null, loadSize: null, maxSize: null, snackStart: true }))
        dispatch(createReportFinderInit());
        try {
            const config = {
                onUploadProgress: progressEvent => {
                    dispatch(uploadProgress({
                        progress: Math.round((progressEvent.loaded * 100) / data.get('File').size),
                        loadSize: Math.round((progressEvent.loaded / 1048576)),
                        maxSize: Math.round((progressEvent.total / 1048576)),
                        snackStart: true
                    }));
                }
            }
            dispatch(createReportFinderStart());

            let res = await rest.post('report-finder/create', data, config);
            if (res.data.status === 200) {
                dispatch(createReportFinderSuccess());
                snackActions.snackBar({
                    message: `${res && res.data && res.data.message ? res.data.message : 'Successfully created report finder.'}`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.status === 200;
            }
            else {
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: true }));
                dispatch(createReportFinderFail());
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: true }))
            dispatch(createReportFinderFail());
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
};

// Delete ReportFinder  action creators
export const bulkDeleteReportFinder = accessControlIds => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, accessControlIds);
    };
};

// Load ReportFinder action creators
export const loadReportFinderInit = () => {
    return crudActions.loadInit();
};
export const loadReportFinderStart = () => {
    return crudActions.loadStart();
};
export const loadReportFinderSuccess = loadedReportFinder => {
    return crudActions.loadSuccess(loadedReportFinder);
};
export const loadReportFinderFail = error => {
    return crudActions.loadFail(error);
};
export const loadReportFinder = (loadData, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadData, options);
    };
};

export const uploadProgress = (data) => {
    return {
        type: 'REPORT_FINDER|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart
    };
};

export const clearStateCreate = () => {
    return ({
        type: 'CLEAR_STATE_CREATE',
    });
}